<h1 mat-dialog-title class="no-margin">{{title.toUpperCase()}}<mat-icon class="close-icon"
                                                                        (click)="onNoClick()">close</mat-icon></h1>
<div class="dialog-body-overflow">

  <!-- <mat-list role="list">

          <mat-list-item role="listitem"
              *ngIf="title == 'COMPETENZE ASSOCIATE' && filteredLista && filteredLista.length > 0">
              <strong class="caption">Lista {{title}}:</strong>

              <span class="grey noFloat" *ngFor="let item of filteredLista" (click)="dettaglioAssociazione(item)">
                  <svg height="12" width="12">
                      <circle cx="6" cy="7" r="4" stroke="black" stroke-width="1" fill="#008047" />
                  </svg>
                  {{item.descrizione}}({{item.tipologia.id}}.{{item.tipologia.descrizione}})
                  {{item.stato.descrizione}}</span>
          </mat-list-item>
          <mat-list-item role="listitem"
              *ngIf="title == 'PROFILI PROFESSIONALI ASSOCIATI' && filteredLista && filteredLista.length > 0"><strong
                  class="caption">Lista {{title}}:</strong>
              <span class="grey noFloat" *ngFor="let item of filteredLista">
                  <svg height="12" width="12">
                      <circle cx="6" cy="7" r="4" stroke="black" stroke-width="1" fill="#008047" />
                  </svg>
                  <span>{{item.nomeProfilo}} ({{item.descrizioneArea.id}}.{{item.descrizioneArea.descrizione}}) -
                      {{item.statoProposta.descrizione}}</span>
                  <mat-icon matTooltip="Dettaglio" class="green" (click)="dettaglioAssociazione(item)">
                      search</mat-icon>
                  <mat-icon matTooltip="Aggiungi codice profilo"
                      *ngIf="!item.codiceProfilo || item.codiceProfilo == null" class="green" (click)="addCode(item)">
                      transit_enterexit</mat-icon>
              </span>
          </mat-list-item>

      </mat-list> -->

  <div class="content-box">
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8"
           *ngIf="title == 'COMPETENZE ASSOCIATE' && filteredLista && filteredLista.length > 0">

      <!--- Note that these columns can be defined in any order.
        The actual rendered columns are set as a property on the row definition" -->

      <!-- Position Column -->
      <ng-container matColumnDef="tipologia">
        <th mat-header-cell *matHeaderCellDef>Tipologia</th>
        <td mat-cell *matCellDef="let element"> {{element.descrizione}} </td>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="competenza">
        <th mat-header-cell *matHeaderCellDef>Competenza</th>
        <td mat-cell *matCellDef="let element"> {{element.tipologia.id}} - {{element.tipologia.descrizione}}
        </td>
      </ng-container>

      <!-- Weight Column -->
      <ng-container matColumnDef="stato">
        <th mat-header-cell *matHeaderCellDef>Stato proposta</th>
        <td mat-cell *matCellDef="let element"> {{element.stato.descrizione}} </td>
      </ng-container>

      <!-- Symbol Column -->
      <ng-container matColumnDef="azioni">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>


    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8"
           *ngIf="title == 'PROFILI PROFESSIONALI ASSOCIATI' && filteredLista && filteredLista.length > 0">

      <!--- Note that these columns can be defined in any order.
        The actual rendered columns are set as a property on the row definition" -->

      <!-- Position Column -->
      <ng-container matColumnDef="tipologia">
        <th mat-header-cell *matHeaderCellDef>Profilo</th>
        <td mat-cell *matCellDef="let element"> {{element.nomeProfilo}} </td>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="competenza">
        <th mat-header-cell *matHeaderCellDef>Area</th>
        <td mat-cell *matCellDef="let element"> {{element.descrizioneArea.id}} -
          {{element.descrizioneArea.descrizione}}</td>
      </ng-container>

      <!-- Weight Column -->
      <ng-container matColumnDef="stato">
        <th mat-header-cell *matHeaderCellDef>Stato proposta</th>
        <td mat-cell *matCellDef="let element"> {{element.statoProposta.descrizione}} </td>
      </ng-container>

      <!-- Symbol Column -->
      <ng-container matColumnDef="azioni">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <mat-icon matTooltip="Dettaglio" class="green" (click)="dettaglioAssociazione(element)">
            search</mat-icon>
          <mat-icon matTooltip="Aggiungi codice profilo"
                    *ngIf="!element.codiceProfilo || element.codiceProfilo == null" class="green"
                    (click)="addCode(element)"> transit_enterexit</mat-icon>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>



</div>
<div mat-dialog-actions class="actions">
  <button mat-fab extended class="searchbox-buttons ripristina-button" (click)="onNoClick()">
    <mat-icon>close</mat-icon>Chiudi
  </button>
</div>
